module.exports = __webpack_public_path__ + "img/estrategia_diario.adad2a88.png";